import { useMemo } from "react";
import { observer } from "mobx-react";
import { hasOlderOriginBuild, RISK_BUFFER_LOCK_BUILD } from "@repo/structure";
import {
  ProjectBuffers,
  SummarySettings,
  useEstimateEditorSettings,
  useEstimateEditorStore,
  useEstimateStructure, VisibilityButton
} from "@tools";
import Grid from "@material-ui/core/Grid";

export const SummaryTableActions = observer(() => {
  const { useProfitability, isSellerOrClient, allowEdition } = useEstimateEditorSettings();
  const { visibilityMode } = useEstimateEditorStore();
  const structure = useEstimateStructure();
  
  const { hideSummary } = structure.visibility;
  
  const showBuffers = useMemo(() => Boolean(
    !hasOlderOriginBuild(RISK_BUFFER_LOCK_BUILD, structure.sOriginBuild)
  ), [structure.sOriginBuild]);
  
  return (
    <Grid
      item container
      alignItems="center"
      wrap="nowrap"
      className="search-bar w-max ml-2"
    >
      {
        visibilityMode &&
        <VisibilityButton
          hidden={hideSummary}
          onChange={structure.visibility.setHideSummary}
        />
      }
      {
        allowEdition && !useProfitability &&
        <SummarySettings isSellerOrClient={isSellerOrClient} />
      }
      {
        allowEdition && !useProfitability && showBuffers &&
        <ProjectBuffers/>
      }
    </Grid>
  );
});